module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "left "
  }, [_vm._v("First Mariner Books edition 2020")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Copyright © 2019 by Howard Norman")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Names: Norman, Howard A., author.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Title: The ghost clause / Howard Norman.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Description: Boston ; New York : Houghton Mifflin Harcourt, 2019. |")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Identifiers: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCCN")]), _vm._v(" 2018036020 (print) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCCN")]), _vm._v(" 2018038075 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780544988064 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780544987296 (hardcover) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780358305620 (paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Subjects: | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BISAC: FICTION")]), _vm._v(" / Literary. | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FICTION")]), _vm._v(" / Family Life. | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FICTION")]), _vm._v(" / Occult & Supernatural.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Classification: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PR")]), _vm._v("9199.3."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("N")]), _vm._v("564 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PR")]), _vm._v("9199.3."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("N")]), _vm._v("564 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("G")]), _vm._v("48 2019 (print) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDC")]), _vm._v(" 813/.54—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LC")]), _vm._v(" record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2018036020",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2018036020")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("Cover design by Martha Kennedy")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Cover photograph © David Crunelle / EyeEm /Getty Images")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Author photograph © Emma Norman")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("v1.0619")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("The author is grateful for permission to reprint “Once Later” by W. S. Merwin, collected in "), _c('em', [_vm._v("Garden Time.")]), _vm._v(" Copyright © 2016 by W. S. Merwin, used by permission of The Wylie Agency, LLC, and Copper Canyon Press.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0